<template>
  <div class="row border m-0 rounded">
    <div
      v-for="option in options"
      :key="option.label"
      class="col-sm-12 py-2"
      :class="option.cols ? option.cols : 'col'"
    >
      <check-box v-model="option.value" :text="option.label" />
    </div>
  </div>
</template>

<script>
import CheckBox from './../Checkbox/View';

export default {
  name: 'MultiCheckBox',
  components: {
    CheckBox,
  },
  props: {
    value: Array,
  },
  data() {
    return {
      options: this.value,
    };
  },
};
</script>
